import validator from 'validator'

// Simple email regex pattern as fallback
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

/**
 * Validates email format
 * @param {string} email - Email to validate
 * @returns {string|undefined} Error message or undefined if valid
 */
export const validateEmail = (email) => {
  if (!email) {
    return 'El correo electrónico es obligatorio'
  }
  
  // Use validator if available, otherwise fallback to regex
  try {
    if (!validator.isEmail(email)) {
      return 'Por favor, introduce un correo electrónico válido'
    }
  } catch (e) {
    // Fallback to simple regex validation
    if (!EMAIL_REGEX.test(email)) {
      return 'Por favor, introduce un correo electrónico válido'
    }
  }
  
  return undefined
}

/**
 * Validates password field
 * @param {string} password - Password to validate
 * @returns {string|undefined} Error message or undefined if valid
 */
export const validatePassword = (password) => {
  if (!password) {
    return 'La contraseña es obligatoria'
  }
  
  if (password.length < 3) {
    return 'La contraseña es demasiado corta'
  }
  
  return undefined
}

/**
 * Validates login form
 * @param {Object} values - Form values
 * @returns {Object} Validation errors
 */
export const validateLoginForm = (values) => {
  const errors = {}
  
  const emailError = validateEmail(values.email)
  if (emailError) {
    errors.email = emailError
  }
  
  const passwordError = validatePassword(values.password)
  if (passwordError) {
    errors.password = passwordError
  }
  
  return errors
}
